// Horse Racing Bot bets as stored in user_bets. They live on the tracker's
// Promo tab: EV bot picks are Promo Bets (bonus back equal to the stake if the
// horse runs 2nd or 3rd), Bonus bot picks are Bonus Turnover (a bonus bet run
// with no lay). Settled by hand from the tracker.

export const HORSE_TAGS = { ev: 'horse_ev', bonus: 'horse_bonus' }

export const isHorseBet = (bet) => bet?.bet_type_tag === HORSE_TAGS.ev || bet?.bet_type_tag === HORSE_TAGS.bonus

// One tracked bet per tip
export const horseBetKey = (bot, marketId) => `${bot}_${marketId}`

export function buildHorseBet(tip, form) {
  const isEv = tip.bot === 'ev'
  return {
    type: 'PROMO',
    promo_type: isEv ? 'Promo Bet' : 'Bonus Turnover',
    bet_type_tag: isEv ? HORSE_TAGS.ev : HORSE_TAGS.bonus,
    sport: 'Horse',
    match: `${tip.venue} R${tip.race_number} · #${tip.runner_number} ${tip.horse_name}`,
    selection: `#${tip.runner_number} ${tip.horse_name}`,
    market_type: 'Win',
    bookmaker: form.bookmaker,
    odds: parseFloat(form.odds),
    stake: parseFloat(form.stake),
    ev_percentage: isEv && tip.ev_percentage != null ? Number(tip.ev_percentage) : null,
    retention_percentage: !isEv && tip.retention_percentage != null ? Number(tip.retention_percentage) : null,
    horse_bot: tip.bot,
    horse_market_id: tip.market_id,
    silk_url: tip.silk_url || null,
    commence_time: tip.start_time,
    bonus_received: false,
    bonus_amount: null,
    // A bonus that came free (no qualifying bet) stays out of pending bonus turnover
    free_bonus: !isEv && !!form.free_bonus,
    status: 'pending',
    actual_profit: null,
    placed_at: new Date().toISOString(),
    settled_at: null,
  }
}

// outcome: 'won' | 'placed' | 'lost'. A placed EV pick loses its stake but
// returns the same amount as a bonus bet, which the Promo tab counts towards
// pending bonus turnover. A losing bonus bet costs nothing.
export function settleHorseBet(bet, outcome) {
  const stake = Number(bet.stake) || 0
  const odds = Number(bet.odds) || 0
  const isBonus = bet.bet_type_tag === HORSE_TAGS.bonus
  const settled_at = new Date().toISOString()
  const round = (v) => Math.round(v * 100) / 100

  if (outcome === 'won') {
    return { ...bet, status: 'won', horse_result: 'WON', actual_profit: round(stake * (odds - 1)), bonus_received: false, bonus_amount: null, settled_at }
  }
  if (outcome === 'placed' && !isBonus) {
    return { ...bet, status: 'lost', horse_result: 'PLACED', actual_profit: -stake, bonus_received: true, bonus_amount: stake, settled_at }
  }
  return { ...bet, status: 'lost', horse_result: 'LOST', actual_profit: isBonus ? 0 : -stake, bonus_received: false, bonus_amount: null, settled_at }
}
